import ReactPlayer from "react-player";
import { IFile } from "./testimonioModel";
import { useEffect, useState } from "react";

interface AudioPlayerProps{
    id : string,
    file: IFile;    
}

const BASE_URL = process.env.PUBLIC_URL
const API_URL = process.env.REACT_APP_API_URL

const auth = JSON.parse(localStorage.getItem("kt-auth-react-v")!);

const xhrSetup = function (xhr: XMLHttpRequest | XMLHttpRequestUpload) {
    const request = xhr as XMLHttpRequest;
    request.setRequestHeader('Authorization', auth.api_token);
};


const AudioPlayer : React.FC<AudioPlayerProps> = ({id, file}) =>{
    const [isModalMapOpen, setIsModalMapOpen] = useState(false);
    
    const abrirVentana = (id: string, event: React.MouseEvent<HTMLAnchorElement>) => {
      // Tu lógica aquí
      const anchoPantalla = window.screen.width;      
      window.open(
        `/testimonial/audio/${id}`, 
        '_blank', 
        `width=${anchoPantalla},height=200`
      );
      console.log('El botón fue clickeado');
    };

    return(
    <div key={file._id} className='audio'>
      <h3 className='mb-4'><a href="#" onClick={(e) => abrirVentana(id, e)}>{file.nombre}</a></h3>                
      <ReactPlayer
        url={`${API_URL}/files/play/${file.nombre}`}                  
        type= {file.tipo}
        width={"100%"}
        height={"60px"}
        controls={true}
        pip={true}
        config={{
          file: {
            hlsOptions: {
              forceHLS: true,
              debug: false,              
              xhrSetup: xhrSetup                  
            },
            attributes: {
              controlsList: 'nodownload',
              crossOrigin: "true"
            } 
          },
        }} 
        />
    </div>
    )

}

export default AudioPlayer